import type { HandoverPhoto } from '@sivan/shared';

/** Uploaded photos not yet attached on the server: never shown as saved before they are. */
export function PendingPhotos({
  photos,
  saved,
}: {
  readonly photos: readonly HandoverPhoto[];
  readonly saved: ReadonlySet<string>;
}) {
  const pending = photos.filter((p) => !saved.has(p.id)).length;
  if (pending === 0) return null;
  return (
    <span className="chip chip--pending">
      {pending === 1 ? 'תמונה אחת ממתינה לשמירה' : `${String(pending)} תמונות ממתינות לשמירה`}
    </span>
  );
}
